module.exports = __webpack_public_path__ + "static/hero-f3ab8d419e5df87a9a6b02d732c731e0.jpg";